import barba from '@barba/core';

export default class{

	constructor(){
        this.switcher_wrapper = '.js-switcher'
        this.switcher_item = '.js-switcher__item'
        this.switcher_pane = '.js-switcher__panel'
        this.active_class = 'is__active'
        const _ua = this._ua(window.navigator.userAgent.toLowerCase())

        barba.hooks.afterOnce(() => {
            if(!_ua.Mobile&&!_ua.Tablet){
                this.init()
            }
        });
        barba.hooks.after(() => {
            if(!_ua.Mobile&&!_ua.Tablet){
                this.init()
            }
        });
    }
    init(){
        this.switcher = document.querySelectorAll(this.switcher_wrapper);
        this.switcher_navs = [];
        if(this.switcher.length > 0){
            this.switcher.forEach( (switcher,i) => {
                const switcher_items = switcher.querySelectorAll( this.switcher_item );
                this.switcher_navs.push( switcher_items )
                if(switcher_items.length > 0){
                    switcher_items.forEach( (switcher_nav,index) => {
                        if(index == 0){
                            const pane_id = switcher_nav.getAttribute('aria-controls');
                            this.switcher_open(switcher_nav,pane_id)
                        }
                        this._addEvent(switcher_nav,i);
                    })
                }
            })
        }      
    }
    _addEvent (el,i){
        el.addEventListener('mouseenter',(e) => {
            this.switcher_hide(i);
            const pane_id = el.getAttribute('aria-controls');
            this.switcher_open(el,pane_id)
        })
        el.addEventListener('mouseleave', (e) => {
            this.switcher_hide(i);
            const pane_id = el.getAttribute('aria-controls');
            this.switcher_close(el,pane_id)
        })
    }
    switcher_open(item,pane_id){
        const target_pane = document.querySelector( '#' + pane_id );
        if ( !target_pane ) return;

        item.classList.add(this.active_class);
        item.setAttribute("aria-selected",true)
        target_pane.classList.add(this.active_class);
        target_pane.removeAttribute("hidden")
    }
    switcher_close(item,pane_id){
        const target_pane = document.querySelector( '#' + pane_id );
        if ( !target_pane ) return;

        item.classList.remove(this.active_class);
        item.setAttribute("aria-selected",false)
        target_pane.classList.remove(this.active_class)
        // target_pane.setAttribute("hidden")
    }
    switcher_hide (i){
        const switcher = this.switcher[i]
        const item_active = switcher.querySelector(this.switcher_item+'.'+this.active_class);
        const pane_active = switcher.querySelector(this.switcher_pane+'.'+this.active_class);
        if(item_active){
            item_active.classList.remove(this.active_class);
            item_active.setAttribute("aria-selected",false)
        }
        if(pane_active){
            pane_active.classList.remove(this.active_class);
            pane_active.setAttribute("hidden","")
        }
    }
    _ua (u){
        return {
            Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) 
            || u.indexOf("ipad") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
            || u.indexOf("kindle") != -1
            || u.indexOf("silk") != -1
            || u.indexOf("playbook") != -1
            || u.indexOf('macintosh') > -1 && 'ontouchend' in document,
            Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
            || u.indexOf("iphone") != -1
            || u.indexOf("ipod") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
            || u.indexOf("blackberry") != -1
        }
    }
}